import React from 'react';
import { connect } from "react-redux";
import SqftCanvas from "./SqftCanvas";
import config from "../store/sqftConfig";
import ExportWorkspaceButton from "../../ar3d/threeD/workspaceComponents/ExportWorkspaceLayoutButton";
import {CANVAS_FIT_MODE} from "../store/canvasHelper";

const SqftCanvasContainer = ({ fitMode = CANVAS_FIT_MODE.WINDOW }) => {
  return (
    <div id="sqft-main-grid" className="sqft-main-grid">
      <div className="threeDWorkspace-tools">
        { config.isDevMode() ? <ExportWorkspaceButton/> : "" }
      </div>
      <SqftCanvas options={{}} fitMode={fitMode}/>
      <div id="angle-tooltip" className="tooltip tooltip-angle">
        {/* ... */}
      </div>
    </div>
  );
};

export default connect()(SqftCanvasContainer);
